import './Heading.css'

function Heading({children}) {
    return(
        <h2 className='heading'>{children}</h2>
    )
}

export default Heading